import ModelFactory from 'business/models/ModelFactory';
import {
  ProteinFormulationClient,
  PFDocDataDTO,
  GlobalIngredientsDTO,
  SavePFIngTypesResult,
  PFDocProteinFormulationInfoDTO,
  ProteinFormulationBasicInfoDTO,
  PFDocSaveResult,
  ProteinFormulationDetailInfoDTO,
  ProteinFormulation,
  ProteinFormulationIngredientTypeDTO,
  ProteinFormulationVariantDTO,
} from 'business/models/Models';
import BaseService from 'business/services/BaseService';

export default class ProteinFormulationService extends BaseService {
  async getProteinFormulationDocData(pfid): Promise<PFDocDataDTO> {
    const pfClient: ProteinFormulationClient = ModelFactory(ProteinFormulationClient);

    const root = await pfClient.retrievePFDocData(pfid);

    return root;
  }

  async uploadPFAttachment(files): Promise<boolean> {
    const pfClient: ProteinFormulationClient = ModelFactory(ProteinFormulationClient);

    const root = await pfClient.uploadAttachment(files);

    return root;
  }

  async saveProteinFormulation(data): Promise<PFDocSaveResult> {
    const pfClient: ProteinFormulationClient = ModelFactory(
      ProteinFormulationClient,
      false,
      true,
    );
    const root = await pfClient.saveProteinFormulation(data);
    return root;
  }

  async savePFIngredientTypes(data): Promise<SavePFIngTypesResult> {
    const pfClient: ProteinFormulationClient = ModelFactory(ProteinFormulationClient);
    const root = await pfClient.saveProteinFormulationIngredientTypes(data);
    return root;
  }

  async getNewProteinFormulationName(parentNodeId): Promise<string> {
    const pfClient: ProteinFormulationClient = ModelFactory(ProteinFormulationClient);
    const root = await pfClient.getNewProteinFormulationName(parentNodeId);
    return root;
  }

  async getGlobalIngredientsData(): Promise<GlobalIngredientsDTO> {
    const pfClient: ProteinFormulationClient = ModelFactory(ProteinFormulationClient);

    const root = await pfClient.loadGlobalIngredientsData();

    return root;
  }

  async getProteinFormulation(id: number): Promise<PFDocProteinFormulationInfoDTO> {
    const pfClient: ProteinFormulationClient = ModelFactory(ProteinFormulationClient);
    return await pfClient.getProteinFormulation(id);
  }

  async getProteinFormulationInfoByName(
    pfName: string,
  ): Promise<ProteinFormulationBasicInfoDTO> {
    const pfClient: ProteinFormulationClient = ModelFactory(
      ProteinFormulationClient,
      false,
      true,
    );
    return await pfClient.getProteinFormulationByName(pfName);
  }

  async getProteinNodeInfo(id: number): Promise<PFDocDataDTO> {
    const pfClient: ProteinFormulationClient = ModelFactory(ProteinFormulationClient);
    return await pfClient.getProteinNodeInfo(id);
  }
  async getProteinFormulationDetailsById(
    id: number,
  ): Promise<ProteinFormulationDetailInfoDTO> {
    const pfClient: ProteinFormulationClient = ModelFactory(
      ProteinFormulationClient,
      false,
      true,
    );
    return await pfClient.getProteinFormulationDetailsInfo(id);
  }

  async getProteinFormulationIngredientsByTreeNodeId(
    treeNodeId: number,
  ): Promise<ProteinFormulation> {
    const pfClient: ProteinFormulationClient = ModelFactory(
      ProteinFormulationClient,
      false,
      true,
    );
    return await pfClient.getProteinFormulationIngredientsByTreeNodeId(treeNodeId);
  }

  async getProteinFormulationIngredientTypes(): Promise<
    ProteinFormulationIngredientTypeDTO[]
  > {
    const pfClient: ProteinFormulationClient = ModelFactory(
      ProteinFormulationClient,
      false,
      true,
    );
    return await pfClient.getProteinFormulationIngredientTypes();
  }

  async createProteinFormulationVariants(
    proteinFormulationVariantDTO: ProteinFormulationVariantDTO,
  ): Promise<boolean> {
    const pfClient: ProteinFormulationClient = ModelFactory(ProteinFormulationClient);
    return await pfClient.createProteinFormulationVariant(proteinFormulationVariantDTO);
  }

  async getProteinFormulationVariants(
    pfTreeNodeId: number,
  ): Promise<ProteinFormulation[]> {
    const pfClient: ProteinFormulationClient = ModelFactory(
      ProteinFormulationClient,
      false,
      true,
    );
    return await pfClient.getProteinFormulationVariants(pfTreeNodeId);
  }
}
